// extracted by mini-css-extract-plugin
module.exports = {"actions":"AwardsActionsCell_actions_a0pW2","error":"AwardsActionsCell_error_36P0R"};